var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-projects"},[(_vm.user.invoices)?_c('Table',{attrs:{"title":"User's Invoices","rows":_vm.user.invoices,"fields":_vm.fields,"collapsed":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }